(function () {
  var STORAGE_KEY = 'mascotAiClosed';

  function isClosed() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === 'true';
    } catch (e) {
      return false;
    }
  }

  function rememberClosed() {
    try {
      sessionStorage.setItem(STORAGE_KEY, 'true');
    } catch (e) {}
  }

  var mascot = document.getElementById('mascot-ai');

  if (isClosed()) {
    mascot.classList.add('hidden');
    return;
  }

  var closeBtn = document.getElementById('mascot-ai-close');
  var slides = mascot.querySelectorAll('.mascot-ai__slide');
  var dots = mascot.querySelectorAll('.mascot-ai__dot');
  var currentSlide = 0;
  var slideCount = slides.length;
  var autoplayInterval = 4000;
  var timer = null;

  function goToSlide(index) {
    slides[currentSlide].classList.remove('active');
    dots[currentSlide].classList.remove('active');
    currentSlide = index % slideCount;
    slides[currentSlide].classList.add('active');
    dots[currentSlide].classList.add('active');
  }

  function nextSlide() {
    goToSlide(currentSlide + 1);
  }

  function startAutoplay() {
    timer = setInterval(nextSlide, autoplayInterval);
  }

  function stopAutoplay() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  closeBtn.addEventListener('click', function () {
    stopAutoplay();
    rememberClosed();
    mascot.classList.add('hidden');
  });

  var marquizBtn = document.getElementById('mascot-ai-button');
  marquizBtn.addEventListener('click', function (e) {
    e.preventDefault();
    if (window.Marquiz) {
      Marquiz.showModal('69a7d74b6ba9c100193e7e18');
    }
  });

  window.addEventListener('load', function () {
    mascot.classList.add('visible');
    startAutoplay();
  });
})();
